import { Grid, useEventCallback } from '@mui/material';
import { memo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import SelectRefCitizenship from 'civil-status/components/shared/select-ref-citizenship';

interface RefCitizenshipProps {
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  onChanges: (values: SectionVM) => void;
  configuration?: string;
  idUseCase?: string;
}

const RefCitizenshipComponent = ({
  disabled = false,
  values,
  errors,
  touched,
  idUseCase,
  onChange,
}: RefCitizenshipProps): React.ReactElement => {
  const onChangeNumberLawCitizenship = useEventCallback((value: string) => {
    onChange('numberLawCitizenship', value);
  });

  return (
    <Grid container spacing={2} item>
      <Grid item xs={12} md={6}>
        <SelectRefCitizenship
          isSmallSize
          id="numberLawCitizenship"
          onChange={onChangeNumberLawCitizenship}
          value={values?.numberLawCitizenship || ''}
          error={touched?.numberLawCitizenship && Boolean(errors?.numberLawCitizenship)}
          disabled={disabled}
          cdUsecase={idUseCase}
          required
        />
      </Grid>
    </Grid>
  );
};

RefCitizenshipComponent.displayName = 'Received By Post component';

const RefCitizenship = memo(RefCitizenshipComponent);

export default RefCitizenship;
